<template>
  <div>
    <v-row type="flex">
      <v-col :xl="12" :lg="12" :md="12" :sm="14" :xs="24" offset="1" class="content-title" style="margin-top: 50px">
        <v-row>
          <div>
            <v-btn icon @click="language = 'de'">
              <De/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'en'">
              <En/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'ar'">
              <Ar/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'tr'">
              <Tr/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'ru'">
              <Ru/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'fr'">
              <Fr/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'es'">
              <Es/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'pl'">
              <Pl/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'pt'">
              <Pt/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'ru'">
              <Ro/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'hr'">
              <Hr/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'it'">
              <It/>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="language = 'cz'">
              <Cs/>
            </v-btn>
          </div>
        </v-row>
        <h1>
          {{ titleTranslated }}
        </h1>
      </v-col>
      <v-col
          :xl="12"
          :lg="12"
          :md="12"
          :sm="12"
          :xs="24"
          align="end"
          class="content-btn pb-4"
      >
      </v-col>
      <v-col cols="10" offset="1"
             v-if="questionsListParsed && questionsListParsed.length > 0"
             :span="20"
      >
        <h3>{{ questionTextTranslation }}</h3>
        <div v-if="currentQuestion.type > 7">{{ currentQuestion.text }}</div>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-text-field v-if="currentQuestion.type === 6"
                        v-model="entry" style="width: 70%"
                        :rules="rules.required" filled/>
          <input v-if="currentQuestion.type === 3 || currentQuestion.type === 4" type="number" v-model="entry"
                 :rules="rules"
                 style="background-color: lightgray" :step="1"/>
          <v-layout v-if="currentQuestion.type === 1">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
              <v-row>
                <v-col>
                  <v-radio-group
                      :rules="[v => !!v || 'Item is required']"
                      v-for="(answer, index) of answerTextTranslation"
                      :key="index"
                      v-model="entry">
                    <v-radio
                        :value="index"
                        :label="answer"/>
                    <!--<label :for="antwort">{{antwort}}</label> -->
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-form>
          </v-layout>


          <input
              filled
              v-if="currentQuestion.type === 5"
              :rules="rules"
              v-model="entry"
              type="date"
              placeholder="Geben Sie ein Datum ein"
          />

          <v-switch v-if="currentQuestion.type === 7" v-model="entry"/>

          <v-layout v-if="currentQuestion.type === 8">
            <v-file-input
                v-model="entry"
                accept="image/*"
                label="File input"
            ></v-file-input>
          </v-layout>

          <v-layout v-if="currentQuestion.type === 2">
            <v-row>
              <v-col>
                <v-form v-for="(answer, index) of answerTextTranslation"
                        :rules="rules"
                        :key="index"
                        v-model="entry">
                  <v-checkbox
                      type="checkbox"
                      :value="index"
                      :label="answer"/>
                  <!-- <label :for="antwort">{{antwort}}</label> -->
                </v-form>
              </v-col>
            </v-row>
          </v-layout>
          <!--<a-form-model-item v-if="currentQuestion.type === 7">
            <a-input v-model="form.desc" type="textarea" />
          </a-form-model-item>-->
          <div></div>
        </v-form>
        <v-btn
            v-if="currentQuestion.type != 9"
            style="margin-top: 20px"
            type="primary"
            @click="onSubmit"
            :disabled="showNextDisabled"
        >
          {{ nextButtonTranslation }}
        </v-btn>
        <!--<v-btn v-else type="primary" @click="toResults">
          Fertig
        </v-btn>-->
        <div></div>
        <!--<a-form-model-item>
          <a-button type="primary" @click="onSubmit"> Speichern </a-button>
        </a-form-model-item> -->
        <v-progress-linear
            style="margin-top: 50px"
            v-model="percentageFinished"
        />
        <template v-if="formerQuestionsList.length > 0">
          <v-select
              placeholder="Zu früheren Fragen zurück"
              style="max-width: 50%"
              :items="formerQuestionsList"
              :item-value="'index'"
              v-model="questionIndex"
          >
            {{ question.text }}
          </v-select>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import jsonLogic from 'json-logic-js'
import Ar from '../../src/components/layout/flags/Ar.vue'
import Cs from '../../src/components/layout/flags/Cs.vue'
import De from '../../src/components/layout/flags/De.vue'
import En from '../../src/components/layout/flags/En.vue'
import Es from '../../src/components/layout/flags/Es.vue'
import Fr from '../../src/components/layout/flags/Fr.vue'
import Hr from '../../src/components/layout/flags/Hr.vue'
import It from '../../src/components/layout/flags/It.vue'
import Pl from '../../src/components/layout/flags/Pl.vue'
import Pt from '../../src/components/layout/flags/Pt.vue'
import Ro from '../../src/components/layout/flags/Ro.vue'
import Ru from '../../src/components/layout/flags/Ru.vue'
import Tr from '../../src/components/layout/flags/Tr.vue'
import axios from '../plugins/axios'

export default {
  components: {
    De, Ar, Cs, En, Es, Fr, Hr, It, Pl, Pt, Ro, Ru, Tr,
  },
  watch: {
    rules() {
      console.log(this.rules)
    }
  },
  data() {
    return {
      valid: false,
      rules: {
        required: value => value.length <= 1 || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      language: 'de',
      formerQuestion: null,
      showSidebar: false,
      openKeys: ['sub1', 'sub2'],
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      formerQuestionsList: [],
      question: {
        question_id: 'bla',
        type: 1,
        text: 'Some question text',
        answers: ['dummy', 'dummy2'],
        rules: [],
      },
      entry: null,
      questionIndex: [0],
      form: {
        name: '',
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    }
  },
  computed: {
    errorMsgTranslated(value, valueSecond) {
      return {
        "datemin": {"de": "Datum muss größer sein als " + value, "en": "Date must be greater than " + value},
        "datemax": {"de": "Datum muss vor " + value + " liegen", "en": "Date must be before " + value},
        "datespan": {
          "de": "Datum muss vor " + value + " und nach " + valueSecond + " liegen",
          "en": "Date must be between " + value + " and " + valueSecond + " liegen"
        },
        "number_min": {},
        "number_max": {},
        "is_not_numeric": {
          "de": "Feld muss eine Zahl sein (mit Punkt statt Komma, und ohne Tausender-Trenner: Beispiel 2000.34)",
          "en": "Field must be a number (with dot instead of )"
        }
      }
    },
    titleTranslated() {
      let defaultText = "Formular zur Erhebung der Immunität"
      if(this.language && this.language != 'de') {
        if(this.language === 'fr') {
          defaultText = 'Enquête sur l´immunité contre le Covid '
        }
        if(this.language === 'en') {
          defaultText = 'Survey on immunity against Covid'
        }
      }
      return defaultText
    },
    nextButtonTranslation() {
      let defaultText = "WEITER"
      if(this.language && this.language != 'de') {
        if(this.language === 'fr') {
          defaultText = 'PROCHAINE QUESTION'
        }
        if(this.language === 'en') {
          defaultText = 'NEXT'
        }
      }
      return defaultText
    },
    questionTextTranslation() {
      let defaultText = this.currentQuestion.text
      if(this.currentQuestion.translation && this.currentQuestion.translation.text) {
        if(this.currentQuestion.translation.text[this.language]) {
          defaultText = this.currentQuestion.translation.text[this.language]
        }
      }
      return defaultText
    },
    answerTextTranslation() {
      let defaultText = this.currentQuestion.answers
      if(this.currentQuestion.translation && this.currentQuestion.translation.answers) {
        if(this.currentQuestion.translation.answers[this.language]) {
          defaultText = this.currentQuestion.translation.answers[this.language]
        }
      }
      return defaultText
    },
    isMandatory() {
      let response = false
      if(this.currentQuestion.required && (this.currentQuestion.required === true || parseInt(this.currentQuestion.required) === 1)) {
        response = true
      }
      return response
    },
    showNextDisabled() {
      let response = false
      if(this.isMandatory && (this.currentQuestion.required && this.entry == null && this.currentQuestion.type != 7)) {
        response = true
      }
      return response
    },
    percentageFinished() {
      const numberOfBlocks = this.questionsListParsed.length
      const currentIndex = this.questionIndex[0] + 1
      let percentage = Math.round(100 * (currentIndex / numberOfBlocks))
      if(percentage > 99) {
        percentage = 99
      }
      return percentage
    },
    currentQuestion() {
      return this.calculateCurrentQuestion(this.questionIndex)
    },
    nextQuestionIndex() {
      const questionIndexCopy = [...this.questionIndex]
      let questionIndexResult = []
      // try increment last counter
      questionIndexCopy[questionIndexCopy.length - 1] =
          questionIndexCopy[questionIndexCopy.length - 1] + 1
      if(
          this.calculateCurrentQuestion(questionIndexCopy) &&
          this.calculateCurrentQuestion(questionIndexCopy).question_id
      ) {
        questionIndexResult = questionIndexCopy
      } else {
        this.removeOneIndexAndCheck(questionIndexCopy)
      }
      return questionIndexResult
    },
    currentQuestionIsLastQuestion() {
      const calculatedNext = this.calculateCurrentQuestion(
          this.nextQuestionIndex
      )
      console.log('NEXT', calculatedNext)
      const isNotLast = calculatedNext && calculatedNext.question_id
      return !isNotLast
    },
    questionsListParsed() {
      return this.$store.state.questionsListParsedTest
    },
    questionUnnested() {
      const returnArray = []
      for(const obj of this.questionsListParsed) {
        console.log(obj)
        this.nestedArrayPush(returnArray, obj)
      }
      return returnArray
    },
  },
  methods: {
    sendFile() {
      let formData = new FormData();
      formData.append('file', this.entry);
      formData.append('uuid', "12345");
      const self = this
      axios.post(this.$store.state.url + 'document/upload', formData).then(response => self.checkIfUpload(response.data))
    },
    validate() {
      console.log('VALIDATED')
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    returnToFormerQuestion() {
      console.log('QUESTION', this.formerQuestion)
      this.questionIndex = this.formerQuestion
    },
    returnToOverview() {
      this.$emit('setStatus', 'overview')
    },
    toResults() {
      this.addCurrentQuestionToFormerQuestionList()
      if(!this.entry) {
        this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, false])
      } else {
        this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.entry])
      }
      this.$emit('setStatus', 'results')
    },
    onSubmit() {
      this.sendFile()
      this.validate()
      if (this.valid) {
        this.addCurrentQuestionToFormerQuestionList()
        if(!this.entry) {
          this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, false])
        } else {
          this.$store.dispatch('setFormResults', [this.currentQuestion.question_id, this.entry])
        }
        this.entry = null
        this.toNextQuestion()
      }
    },
    nestedArrayPush(array, obj) {
      const objCopy = {...obj}
      delete objCopy.children
      array.push(objCopy)
      if(obj.children) {
        for(const child of obj.children) {
          this.nestedArrayPush(array, child)
        }
      }
    },
    calculateCurrentQuestion(indexArray) {
      if(this.questionsListParsed && this.questionsListParsed.length > 0) {
        let questionPart = [...this.questionsListParsed]
        for(let i = 0; i < indexArray.length; i++) {
          if(i < 1) {
            questionPart = this.questionsListParsed[indexArray[i]]
          } else {
            questionPart = {...questionPart}.children[indexArray[i]]
          }
        }
        return questionPart
      } else return {}
    },
    toNextQuestion() {
      this.questionIndex = [...this.nextQuestionIndex]
      const results = this.$store.state.questionnaireResults
      const newQuestion = {
        ...this.calculateCurrentQuestion(this.questionIndex),
      }
      if(newQuestion.rule_id && newQuestion.rule) {
        const rule = newQuestion.rule
        if(jsonLogic.apply(rule, results)) {
          this.toNextQuestion()
        }
      }
      if(!this.currentQuestion.type) {
        this.goToNextChild()
      }
    },
    goToNextChild() {
      const currentQuestionIndex = [...this.questionIndex]
      const results = this.$store.state.questionnaireResults
      currentQuestionIndex.push(0)
      this.questionIndex = [...currentQuestionIndex]
      const newQuestion = {
        ...this.calculateCurrentQuestion(currentQuestionIndex),
      }
      if(newQuestion.rule_id && newQuestion.rule) {
        const rule = newQuestion.rule
        if(jsonLogic.apply(rule, results)) {
          this.toNextQuestion()
        }
      }
      if(!this.currentQuestion.type) {
        this.goToNextChild()
      }
    },
    addCurrentQuestionToFormerQuestionList() {
      const obj = {...this.currentQuestion}
      obj.index = [...this.questionIndex]
      if(
          this.formerQuestionsList.filter(
              (listObj) => listObj.question_id === obj.question_id
          ).length < 1
      ) {
        this.formerQuestionsList.push(obj)
      }
    },
    removeOneIndexAndCheck(questionIndexCopy) {
      if(questionIndexCopy.length > 1) {
        questionIndexCopy.pop()
        questionIndexCopy[questionIndexCopy.length - 1] =
            questionIndexCopy[questionIndexCopy.length - 1] + 1
        if(
            this.calculateCurrentQuestion(questionIndexCopy) &&
            this.calculateCurrentQuestion(questionIndexCopy).question_id
        ) {
          this.questionIndex = questionIndexCopy
        } else {
          this.removeOneIndexAndCheck(questionIndexCopy)
        }
      }
    },
  },
}
</script>
